module.exports = __webpack_public_path__ + "static/img/BO.c5f70674.jpg";